<template>
	<div class="main__container position-relative d-block">
		<navbar></navbar>
		<router-view></router-view>
		<footer-part></footer-part>
	</div>
</template>

<script>
	import Navbar from './components/Navbar.vue';
	import Footer from './components/Footer.vue';
	
	export default {
		components: {
			'navbar' : Navbar,
			'footer-part' : Footer
		}
	}
</script>
<style src="./assets/css/bootstrap.min.css"></style>
<style src="./assets/css/style.css"></style>


// WEBPACK FOOTER //
// src/App.vue